import { Container } from 'react-bootstrap';
import parse from 'html-react-parser';
import { motion } from 'framer-motion';
import { useTranslation } from 'react-i18next';
import { useHomeTranslationsQuery } from '../../../services/HomePageServices';
import { sanitizeCmsHtml } from '../../../helpers/sanitizeCmsHtml';

// Framer motion animation for entering animation
const initial = {
  y: '1rem',
  opacity: 0,
};

const animate = {
  y: 0,
  opacity: 1,
};

const transition = {
  duration: 1,
  ease: 'easeOut',
  delay: 0.5,
};

function ImageBanner() {
  const {data: homeTranslations, isLoading} = useHomeTranslationsQuery();
  const { t, i18n } = useTranslation('herobanner');

  const bannerContent =
    homeTranslations?.find((entry) => entry.languages_code === i18n.language) ??
    homeTranslations?.[0];

  const bannerImage = bannerContent?.banner_image ?? t('banner_image');
  const mobileBannerImage = bannerContent?.mobile_kv ?? t('mobile_kv');
  const hasMobileBannerImage = !!mobileBannerImage && mobileBannerImage !== 'mobile_kv';
  const bannerImageDisclaimer = sanitizeCmsHtml(t('banner_image_disclaimer'));

  if (!homeTranslations || isLoading) return null;
  return (
    <section id="about-session" className="hero-banner">
      <img
        className="hero-banner__img"
        src={bannerImage}
        loading="eager"
        decoding="async"
        fetchPriority="high"
        tabIndex={-1}
        alt={t('banner_image_alt_text')}
      />
      <img
        className="hero-banner__img_responsive"
        src={hasMobileBannerImage ? mobileBannerImage : bannerImage}
        loading="lazy"
        decoding="async"
        fetchPriority="low"
        tabIndex={-1}
        alt={t('banner_image_alt_text')}
      />
      <div className="hero-banner__text-wrapper">
        <Container className="container">
          <motion.span
            initial={initial}
            animate={animate}
            transition={transition}
            className="hero-banner__headline"
          >
          </motion.span>
          <motion.h1
            initial={initial}
            animate={animate}
            transition={transition}
            className="hero-banner__title"
          >
            {t('banner_title')}
          </motion.h1>
          <motion.span
            initial={initial}
            animate={animate}
            transition={transition}
            className="hero-banner__text"
          >
            {parse(sanitizeCmsHtml(t('banner_description')))}
          </motion.span>
          <motion.span
            initial={initial}
            animate={animate}
            transition={transition}
            className="hero-banner__text_responsive"
          >
            {parse(sanitizeCmsHtml(t('banner_description_mobile')))}
          </motion.span>
        </Container>
      </div>
      {bannerImageDisclaimer && (
        <div className="hero-banner__disclaimer-wrapper">
          <Container className="container">
            <div className="hero-banner__disclaimer">
              {parse(bannerImageDisclaimer)}
            </div>
          </Container>
        </div>
      )}
    </section>
  );
}

export default ImageBanner;